import { z } from "zod";
import { ja } from "zod/locales";

// client app の zod インスタンスのグローバル設定 (副作用 import)。 root.tsx と vitest.setup.ts の
// 双方で読み込み、 ランタイムとテストでメッセージ挙動を一致させる。
//
// zod の設定はスキーマ層 (@packages/schema) に集約せず、 利用先 (consumer) で行う方針。
// form の表示メッセージ (ja ロケール + 必須 string 未入力の friendly メッセージ) は presentation 関心の
// ため、 それを必要とする client でのみ適用する。 @packages/schema 自身は z.config を呼ばないので、
// form を持たない server 側 (api / console / domain) は zod 既定 (英語) メッセージのままで良い。
//
// 必須 string 未入力を friendly メッセージにする (Conform は空入力を undefined 化するため
// invalid_type に、 直接 parse の空文字は too_small(min 1) になる)。 特定文言が要るフィールドは
// schema 定義側で上書きできる (優先順位: schema > parse > グローバル customError > ロケール)。
const requiredStringErrorMap: z.core.$ZodErrorMap = (iss) => {
    if (iss.code === "invalid_type" && iss.expected === "string" && iss.input === undefined) {
        return "入力必須です。";
    }
    if (iss.code === "too_small" && iss.origin === "string" && iss.minimum === 1) {
        return "入力必須です。";
    }
    return undefined;
};

// client の zod インスタンスのグローバル設定。 client で定義する form schema
// (exampleFormSchema 等、 client の z で組み立てるもの) に効く。
z.config(ja()); // 日本語ロケール (最下位の既定メッセージ)。
z.config({ customError: requiredStringErrorMap });

// 上記グローバル設定と同等の error map を 1 つに合成したもの。
// ESM 出力化 (client のプリバンドル撤去) 後は client と @packages/schema が同一の zod インスタンスを
// 共有するため、 上記グローバル設定は @packages/schema のスキーマ parse にも届く。 本 map は safeParse の
// per-parse error option に明示的に渡したい経路 (例: item edit の clientAction) 向けに維持する
// (グローバル設定に依存せず parse 単位で friendly メッセージを保証する)。
const jaLocaleError = ja().localeError;
export const formErrorMap: z.core.$ZodErrorMap = (iss) => requiredStringErrorMap(iss) ?? jaLocaleError?.(iss);
